import { gql } from '@apollo/client'

export const createDonation = gql`
  mutation createDonation($data: CreateDonationInput!) {
    createDonation(data: $data) {
      success
      error
      contributions {
        id
        amount
        netAmount
        fee
        state
      }
    }
  }
`

export const createGuestDonation = gql`
  mutation createGuestDonation($userId: Int!, $data: CreateDonationInput!) {
    createGuestDonation(userId: $userId, data: $data) {
      success
      error
      contributions {
        id
        amount
        netAmount
        fee
        state
      }
    }
  }
`
